import { FC } from 'react';

import { ProgressBar } from '../ProgressBar/ProgressBar';
import type { ITimerChildrenProps } from '../Timer/Timer';
import { Timer } from '../Timer/Timer';

export interface IProgressionBarProps {
  className: string;
  durationInMilliseconds: number;
  onCancel?: () => void;
  onTimeout?: () => void;
  startDate: Date;
  text?: string;

  size?: 'small' | 'medium' | 'large';
  startFromRight?: boolean;
}

function getPercent(elapsedTime: number, duration: number, startFromRight = false): number {
  const result = Math.round((elapsedTime * 100) / duration);
  return startFromRight ? 100 - result : result;
}

export const ProgressionBar: FC<IProgressionBarProps> = props => {
  return (
    <div className="progression-bar-component">
      <div className="progression-bar-title">{props.text || ''}</div>
      {props.durationInMilliseconds ? (
        <Timer duration={props.durationInMilliseconds} startDate={props.startDate} onTimerEnded={props.onTimeout}>
          {({ elapsedTime }: ITimerChildrenProps) => (
            <ProgressBar
              percent={getPercent(elapsedTime, props.durationInMilliseconds, props.startFromRight)}
              className={props.className}
              size={props.size}
            />
          )}
        </Timer>
      ) : null}
      {props.durationInMilliseconds && props.onCancel ? (
        <div className="progression-bar-cancel" onClick={props.onCancel}>
          <i className="fa fa-times" aria-hidden="true" />
        </div>
      ) : null}
    </div>
  );
};
